import {notify} from '@gemcook/notification';

import api from '@api';
import constants from '@constants';

/**
 * カード情報を取得する
 * @param customerId
 */
export const getCardInfo = async (customerId: string) => {
  const stripeCustomer = await api.payments.getOneCustomer(customerId);

  if (stripeCustomer.sources.data.length === 0) {
    return null;
  } else {
    return stripeCustomer.sources.data[0];
  }
};

/**
 * カードを保持しているかを判定する
 * @param customerId カスタマーID
 */
export const hasCard = async (customerId: string): Promise<boolean> => {
  if (!customerId) {
    return false;
  }

  const stripeCustomer = await api.payments.getOneCustomer(customerId);

  if (stripeCustomer.sources.data.length === 0) {
    return false;
  } else {
    return true;
  }
};

/**
 * 使用状況の更新
 * @param me
 */
export const updateUsage = async (me: MeStore) => {
  if (me.plan !== constants.PLAN.FREE) {
    const usageRecordBody: PaymentCreateUsageRecordBody = {
      customerId: me.customerId,
      teamId: me.teamId,
    };

    await api.payments.createUsageRecord(usageRecordBody);
  }
};

/**
 * 契約中のプランがあるかを判定する
 */
// export const isSubscription = async (customerId: string): Promise<boolean> => {
//   const customer = await api.payments.getOneCustomer(customerId);
//   console.log(sub)
//   return true;
// };

/**
 * Stripeのエラーメッセージを整形する
 * @param message
 */

export const getErrors = (error: {message: string}) => {
  switch (error.message) {
    case 'card information is invalid':
      notify('無効なクレジットカード情報です', 'error', undefined, 5);
      break;
    case 'card was declined':
      notify(
        '決済に失敗しました。別のクレジットカードを使用してください。',
        'error',
        undefined,
        5
      );
      break;

    default:
      notify(
        'エラーが発生しました。時間を空けて再度登録してください',
        'error',
        undefined,
        5
      );
      break;
  }
};
